import { render, staticRenderFns } from "./CorrecaoTitulo.vue?vue&type=template&id=bcf052e4&scoped=true"
import script from "./CorrecaoTitulo.vue?vue&type=script&lang=js"
export * from "./CorrecaoTitulo.vue?vue&type=script&lang=js"
import style0 from "./CorrecaoTitulo.vue?vue&type=style&index=0&id=bcf052e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf052e4",
  null
  
)

export default component.exports